import React from 'react';

import {ActionPlanImpactLevel, Maybe} from '#apollo/schema';

import * as css from './ImpactTag.css';
type ImpactLevel = Maybe<ActionPlanImpactLevel> | undefined;
function ImpactTag({impactLevel}: {impactLevel?: ImpactLevel}) {
  if (!impactLevel) return null;
  return <div className={css.impactTag}>{impactLevel} impact</div>;
}

export {ImpactTag};
